<template>
  <div style="position: relative">
    <div id="legend" v-show="this.nodes.length > 0"></div>
    <svg id="cxstar_knowledge_graph" :width="kg_width" :height="kg_height"></svg>
    <div
      v-show="is_node_focus"
      style="width: 280px; overflow: auto; position: absolute; top: 2px; right: 2px; opacity: 0.8; background-color: #fff; padding: 10px; padding-top: 15px; box-shadow: 0 0 2px rgb(52 58 67 / 10%), 0 1px 2px rgb(52 58 67 / 8%), 0 1px 4px rgb(52 58 67 / 8%)"
      :style="'height:' + kg_height + 'px'"
    >
      <div style="margin: 5px 0; line-height: 32px">
        <span id="type" style="text-align: left; font-size: 14px; border-radius: 4px; margin-right: 10px; padding: 8px 10px; line-height: 26px"></span>
        <div style="font-size: 16px; font-weight: bold"><a id="remarks" target="_blank"></a></div>
      </div>
      <!-- <div id="tag" style="text-align: left; font-size: 15px;"></div> -->
      <!-- <div style="text-align: left; font-size: 15px;"></div> -->
      <div style="text-align: left; font-size: 15px">
        <div id="desc_lab" style="font-weight: bold">简介</div>
        <div id="desc"></div>
      </div>
      <div style="text-align: left; font-size: 15px; margin-top: 10px">
        <!-- <slot>默认插槽，没传入内容就会默认显示这句话</slot> -->
        <slot></slot>
        <!-- <div id="link_art_lab" style="font-weight: bold;">相关文章</div>
        <div id="link_art"></div> -->
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
// import * as d3 from './d3.v7.js';
import * as d3 from "../assets/js/d3.v58.js";
export default {
  name: "KnowledgeGraph",
  // // 接受父组件的值
  // props: ["size", "data",],
  data() {
    return {
      nodes: [
        // { id: 1, name: '湖南邵阳', type: 1 },
        // { id: 2, name: '山东泰安', type: 1 },
        // { id: 3, name: '广东阳江不知道怎么回', type: 1 },
        // { id: 4, name: '山西太原', type: 1 },
        // { id: 5, name: '亮', type: 2 },
        // { id: 6, name: '丽', type: 2 },
        // { id: 7, name: '雪', type: 2 },
        // { id: 8, name: '小明', type: 2 },
        // { id: 9, name: '组长', type: 2 }
      ],
      tempEdges: [
        // { id: 1, source: 1, target: 5, relation: '籍贯' },
        // { id: 2, source: 5, target: 6, relation: '舍友' },
        // { id: 3, source: 5, target: 7, relation: '舍友' },
        // { id: 4, source: 5, target: 8, relation: '舍友' },
        // { id: 5, source: 2, target: 7, relation: '籍贯' },
        // { id: 6, source: 3, target: 6, relation: '籍贯' },
        // { id: 7, source: 4, target: 8, relation: '籍贯' },
        // { id: 8, source: 6, target: 7, relation: '同学' },
        // { id: 9, source: 7, target: 8, relation: '朋友' },
        // { id: 10, source: 7, target: 9, relation: '职责' },
        // { id: 11, source: 9, target: 7, relation: '人物' },
        // { id: 12, source: 9, target: 7, relation: '哈哈哈' }
      ],
      links: null,
      linksText: null,
      nodesData: null,
      edges: null,
      gs: null,
      forceSimulation: null, // 力图
      imgCase: null, // 图例
      kg_width: 900,
      kg_height: 600,
      node_color_choice: ["rgb(245, 118, 190)", "rgb(118, 202, 223)", "rgb(158, 158, 200)"],
      link_color_choice: ["#bbb"],
      is_node_focus: false,
    };
  },
  // mounted() {
  //   this.addImgCase()
  // },
  methods: {
    // // 图例计数
    // coutImgCase() {

    //   this_.gs.selectAll('.circle')._parents.forEach(function(item, index) {
    //     // console.log(item)
    //     // console.log(item.__data__)
    //     // console.log(item.__data__.type)
    //     // console.log(d.type)
    //     if(item.__data__.type != d.type) {
    //       item.style.opacity = '0.2'
    //     }
    //   })
    // },
    // 添加图例
    addImgCase() {
      let legendData = [
        { name: "文章", type: "__Document__", color: this.node_color_choice[0] },
        { name: "社区", type: "__Community__", color: this.node_color_choice[2] },
        { name: "知识点", type: "__Entity__", color: this.node_color_choice[1] },
      ];

      this.imgCase = d3.select("#legend");

      let this_ = this;
      let legendItems = this.imgCase
        .selectAll(".legend-item")
        .data(legendData)
        .enter()
        .append("div")
        .attr("class", "legend-item")
        .style("background-color", function (d) {
          return d.color;
        })
        .text(function (d) {
          return d.name;
        })
        .on("mouseover", function (d, i) {
          this_.gs.selectAll(".circle")._parents.forEach(function (item, index) {
            // console.log(item)
            // console.log(item.__data__)
            // console.log(item.__data__.type)
            // console.log(d.type)
            if (item.__data__.type != d.type) {
              item.style.opacity = "0.2";
            }
          });
          // console.log(this_.gs.selectAll('.circle')._parents)
          // console.log(d)
          // console.log(i)
          // // 显示连接线上的文字
          // this_.toggleLineText(d, true)
          // this_.toggleLine(this_.links, d, true)
          // this_.toggleNode(this_.gs, d, true, linkMap)
        })
        .on("mouseout", function (d, i) {
          this_.gs.selectAll(".circle")._parents.forEach(function (item, index) {
            if (item.__data__.type != d.type) {
              item.style.opacity = "1";
            }
            // console.log(item)
            // console.log(item.__data__.type)
            // console.log(indxe)
          });
        });
    },
    // 扩展其他信息
    extendOtherMsg(currentNode) {
      this.$emit("extendOtherMsg", currentNode.id);
    },
    // 加载知识图谱
    initKnowledgeGrapg(kg_size, kg_base_data) {
      // 接收传值
      [this.kg_width, this.kg_height] = kg_size;
      this.nodes = kg_base_data.nodes;
      this.tempEdges = kg_base_data.relationships;

      // 渲染知识图谱
      this.drawChart();
      // 添加图例
      this.addImgCase();
    },
    // 让父组件加载数据再调用子组件方法展开知识图谱
    getKnowledgeDataAndExtendGraph(currentNode) {
      this.$emit("extendKnowledgeGraph", currentNode.id);
    },
    // 展开知识图谱
    extendKnowledgeGraph(cur_node_id, kg_extend_data) {
      if (kg_extend_data != null) this.showMyList(cur_node_id, kg_extend_data);
      // else {alert('知识图谱为空')}
    },
    // 处理节点文字不换行，超出隐藏
    textHiding(d3text, text) {
      if (text.length > 20) text = text.substring(0, 20) + "...";
      d3text.append("tspan").attr("x", 0).attr("y", -3).text(text);
    },
    // 处理节点文字换行
    textBreaking(d3text, text) {
      const len = text.length;
      if (len <= 3) {
        d3text.append("tspan").attr("x", 0).attr("y", -3).text(text);
      } else {
        const topText = text.substring(0, 3);
        const midText = text.substring(3, 7);
        let botText = text.substring(7, len);
        let topY = -22;
        let midY = 8;
        let botY = 34;
        if (len <= 9) {
          topY += 10;
          midY += 10;
        } else {
          botText = text.substring(7, 9) + "...";
        }
        d3text.text("");
        d3text
          .append("tspan")
          .attr("x", 0)
          .attr("y", topY)
          .text(function () {
            return topText;
          });
        d3text
          .append("tspan")
          .attr("x", 0)
          .attr("y", midY)
          .text(function () {
            return midText;
          });
        d3text
          .append("tspan")
          .attr("x", 0)
          .attr("y", botY - 7)
          .text(function () {
            return botText;
          });
      }
    },
    // drag
    started(d) {
      if (!d3.event.active) {
        this.forceSimulation.alphaTarget(0.8).restart(); // 设置衰减系数，对节点位置移动过程的模拟，数值越高移动越快，数值范围[0, 1]
      }
      d.fx = d.x;
      d.fy = d.y;
    },
    dragged(d) {
      d.fx = d3.event.x;
      d.fy = d3.event.y;
    },
    ended(d) {
      if (!d3.event.active) {
        this.forceSimulation.alphaTarget(0);
      }
      d.fx = null;
      d.fy = null;
    },
    //删除当前及下一级没有其他关系的节点
    deleteNextNodes(curr) {
      let this_ = this;
      this_.is_node_focus = false; // 删除节点隐藏右侧菜单
      // document.getElementById('remarks').innerText = '';

      // let removeIndex = this_.nodesData.findIndex(node => node.id == curr.id)
      // this_.nodesData.splice(removeIndex, 1)
      // this_.nodes.splice(removeIndex, 1)

      // console.log(this_.nodes)
      // console.log(this_.nodesData)
      // console.log(this_.tempEdges)

      // // d3.select(this).remove();
      // let relationNode = [],
      //   relationList = []
      //   // hasRelationList = []

      var click_node_id = curr.id; //点击节点的名字
      function digui_delete_node_and_link(click_node_id) {
        d3.selectAll(".lines").each(function (e) {
          if (e.source.id == click_node_id) {
            // 刪除来源是该节点的边
            // console.log(222)
            // console.log(e)
            // console.log(333)
            let removeIndex = this_.tempEdges.findIndex(line => line.id == e.id);
            this_.tempEdges.splice(removeIndex, 1);
            this_.links._groups[0].splice(removeIndex, 1);
            this_.linksText._groups[0].splice(removeIndex, 1);
            d3.select(this).remove();

            // 删除边的目标节点，以及目标节点的子节点
            // let target_node_id = e.target.id
            d3.selectAll(".singleNode").each(function (d, i) {
              let temp = d.id;
              //删除当前需要隐藏的节点
              if (temp == e.target.id) {
                this_.removeSingle();
                d3.select(this).remove();
                let removeIndex = this_.nodesData.findIndex(node => node.id == temp);
                this_.nodesData.splice(removeIndex, 1);
                this_.nodes.splice(removeIndex, 1);
                // this_.nodesData.splice(d3.select(this)._groups[0][0].__data__.id, 1)
                // this_.nodes.splice(d3.select(this)._groups[0][0].__data__.id, 1)

                // 递归删除子节点和边
                digui_delete_node_and_link(e.target.id);
              }
            });
          }
          // else {
          //   relationList.push(e)//出去跟删除节点有关系的其他关系
          // }
          // //需要删除的节点相关的节点
          // if (e.source.id == curr.id) {
          //   relationNode.push(e.target)
          // }
          // //需要删除的节点相关的节点
          // if (e.target.id == curr.id) {
          //   relationNode.push(e.source)
          // }
        });
      }
      digui_delete_node_and_link(click_node_id);

      // d3.selectAll(".lines").each(function (e) {
      //   if (e.source.id == curr.id) {
      //     while(e.target.id != null) {

      //     }
      //     console.log(222)
      //     console.log(e)
      //     console.log(333)
      //     let removeIndex = this_.tempEdges.findIndex(line => line.id == e.id)
      //     this_.tempEdges.splice(removeIndex, 1)
      //     this_.links._groups[0].splice(removeIndex, 1)
      //     this_.linksText._groups[0].splice(removeIndex, 1)
      //     d3.select(this).remove();
      //   }
      //   // else {
      //   //   relationList.push(e)//出去跟删除节点有关系的其他关系
      //   // }
      //   // //需要删除的节点相关的节点
      //   // if (e.source.id == curr.id) {
      //   //   relationNode.push(e.target)
      //   // }
      //   // //需要删除的节点相关的节点
      //   // if (e.target.id == curr.id) {
      //   //   relationNode.push(e.source)
      //   // }
      // })

      // d3.selectAll(".lines").each(function (e) {
      //   if (e.source.id == curr.id) {
      //     console.log(222)
      //     console.log(e)
      //     console.log(333)

      //     // let removeIndex = this_.tempEdges.findIndex(line => line.id == e.id)
      //     // this_.tempEdges.splice(removeIndex, 1)
      //     // this_.links._groups[0].splice(removeIndex, 1)
      //     // this_.linksText._groups[0].splice(removeIndex, 1)
      //     // d3.select(this).remove();
      //   }
      // })

      // 删除多余的孤立节点
      if (d3.selectAll(".singleNode")._groups.length > 1) {
        // 只剩一个根节点的话，根节点也是孤立节点，但是根节点不删除
        d3.selectAll(".singleNode").each(function (d, i) {
          let node_id = d.id;
          let node_has_no_son_flag = true;
          d3.selectAll(".lines").each(function (e) {
            if (e.source.id == node_id || e.target.id == node_id) {
              node_has_no_son_flag = false;
            }
          });
          // this_.removeSingle()
          // d3.select(this).remove();
          if (node_has_no_son_flag) {
            let removeIndex = this_.nodesData.findIndex(node => node.id == node_id);
            this_.nodesData.splice(removeIndex, 1);
            this_.nodes.splice(removeIndex, 1);
            // d3.select(this).remove();
          }
        });
      }
      // console.log(1111)
      // console.log(this_.nodes)
      // console.log(this_.nodesData)
      // console.log(this_.tempEdges)
      // console.log(this_.links._groups[0])
      // console.log(this_.linksText._groups[0])
      // console.log(1111)

      // var tempNodeList = JSON.parse(JSON.stringify(relationNode))
      // tempNodeList = this_.uniqObjInArray(tempNodeList)
      // //区分下级节点是否是孤节点
      // tempNodeList.forEach(function (item, index) {
      //   var hasLine = relationList.findIndex(jtem => jtem.target.id == item.id || jtem.source.id == item.id)
      //   if (hasLine >= 0) {
      //     item.notSingle = true
      //   }
      // })
      // tempNodeList.forEach(function (item, index) {
      //   if (!item.notSingle) {
      //     d3.select('#singleNode' + item.id).remove()
      //     let removeIndex = this_.nodesData.findIndex(node => node.id == item.id)
      //     this_.nodesData.splice(removeIndex, 1)
      //     this_.nodes.splice(removeIndex, 1)
      //     this_.removeSingle()
      //     d3.select(this).remove();
      //   }
      // })

      // var otherTempNode = [];
      // tempNodeList = tempNodeList.map(item => {
      //   if (!item.notSingle) {
      //     otherTempNode.push(item)
      //   }
      // })
      // hasRelationList.forEach(item => {
      //   otherTempNode.forEach(jtem => {
      //     if (jtem.id == item.source.id || jtem.id == item.target.id) {
      //       d3.select('#edgepath' + item.id).remove()
      //     }
      //   })
      // })

      // console.log(this_.nodes)
      // console.log(this_.nodesData)
      // console.log(this_.tempEdges)
      // console.log(this_.links._groups[0])
      // console.log(this_.linksText._groups[0])

      // d3.selectAll(".singleNode").each(function (d, i) {
      //   var temp = d.id;
      //   //删除当前需要隐藏的节点
      //   if (temp == clickNode) {
      //     this_.removeSingle()
      //     d3.select(this).remove();
      //     // this_.nodesData.splice(d3.select(this)._groups[0][0].__data__.id, 1)
      //     // this_.nodes.splice(d3.select(this)._groups[0][0].__data__.id, 1)
      //   }
      // });
      d3.selectAll(".linksText").each(function (e) {
        if (e.source === curr || e.target === curr) {
          d3.select(this).remove();
        }
      });
      this_.gs.style("opacity", 1);
      this_.links.style("opacity", 1).classed("link-active", false);
    },
    isLinkLine(node, link) {
      return link.source.id === node.id;
    },
    toggleLine(linkLine, currNode, isHover) {
      if (isHover) {
        // 加重连线样式
        this.links
          .style("opacity", 0.1)
          .filter(link => this.isLinkLine(currNode, link))
          .style("opacity", 1)
          .classed("link-active", true);
      } else {
        this.links.style("opacity", 1).classed("link-active", false);
      }
    },
    toggleLineText(currNode, isHover) {
      if (isHover) {
        this.linksText.style("fill-opacity", function (edge) {
          if (edge.source === currNode) {
            return 1;
          }
        });
      } else {
        this.linksText.style("fill-opacity", function (edge) {
          if (edge.source === currNode || edge.target === currNode) {
            return 0;
          }
        });
      }
    },
    // 生成关系连线路径
    genLinkPath(link) {
      const count = link.count;
      const index = link.index;
      let sx = link.source.x;
      let tx = link.target.x;
      let sy = link.source.y;
      let ty = link.target.y;
      return "M" + sx + "," + sy + " L" + tx + "," + ty;
    },
    ticked() {
      // 连线路径
      this.links.attr("d", link => this.genLinkPath(link));
      // 连线文字位置
      this.linksText
        .attr("x", function (d) {
          return (d.source.x + d.target.x) / 2;
        })
        .attr("y", function (d) {
          return (d.source.y + d.target.y) / 2;
        });
      // 节点位置
      this.gs.attr("transform", function (d) {
        return "translate(" + d.x + "," + d.y + ")";
      });
    },
    // 关联节点去重重组
    uniqObjInArray(objarray) {
      let len = objarray.length;
      let tempJson = {};
      let res = [];
      for (let i = 0; i < len; i++) {
        //取出每一个对象
        tempJson[JSON.stringify(objarray[i])] = true;
      }
      let keyItems = Object.keys(tempJson);
      for (let j = 0; j < keyItems.length; j++) {
        res.push(JSON.parse(keyItems[j]));
      }
      return res;
    },
    //删除当前及下一级没有其他关系的节点
    deleteNode(curr) {
      let this_ = this;
      this_.is_node_focus = false; // 删除节点隐藏右侧菜单
      // document.getElementById('remarks').innerText = '';

      let removeIndex = this_.nodesData.findIndex(node => node.id == curr.id);
      this_.nodesData.splice(removeIndex, 1);
      this_.nodes.splice(removeIndex, 1);

      // console.log(this_.nodes)
      // console.log(this_.nodesData)
      // console.log(this_.tempEdges)

      d3.select(this).remove();
      let relationNode = [],
        relationList = [];
      var clickNode = curr.id; //点击节点的名字
      d3.selectAll(".lines").each(function (e) {
        if (e.source.id == curr.id || e.target.id == curr.id) {
          let removeIndex = this_.tempEdges.findIndex(line => line.id == e.id);
          this_.tempEdges.splice(removeIndex, 1);
          this_.links._groups[0].splice(removeIndex, 1);
          this_.linksText._groups[0].splice(removeIndex, 1);
          d3.select(this).remove();
        } else {
          relationList.push(e); //出去跟删除节点有关系的其他关系
        }
        //需要删除的节点相关的节点
        if (e.source.id == curr.id) {
          relationNode.push(e.target);
        }
        //需要删除的节点相关的节点
        if (e.target.id == curr.id) {
          relationNode.push(e.source);
        }
      });

      var tempNodeList = JSON.parse(JSON.stringify(relationNode));
      tempNodeList = this_.uniqObjInArray(tempNodeList);
      //区分下级节点是否是孤节点
      tempNodeList.forEach(function (item, index) {
        var hasLine = relationList.findIndex(jtem => jtem.target.id == item.id || jtem.source.id == item.id);
        if (hasLine >= 0) {
          item.notSingle = true;
        }
      });
      tempNodeList.forEach(function (item, index) {
        if (!item.notSingle) {
          d3.select("#singleNode" + item.id).remove();
          let removeIndex = this_.nodesData.findIndex(node => node.id == item.id);
          this_.nodesData.splice(removeIndex, 1);
          this_.nodes.splice(removeIndex, 1);
        }
      });

      // console.log(this_.nodes)
      // console.log(this_.nodesData)
      // console.log(this_.tempEdges)
      // console.log(this_.links._groups[0])
      // console.log(this_.linksText._groups[0])

      d3.selectAll(".singleNode").each(function (d, i) {
        var temp = d.id;
        //删除当前需要隐藏的节点
        if (temp == clickNode) {
          this_.removeSingle();
          d3.select(this).remove();
          // this_.nodesData.splice(d3.select(this)._groups[0][0].__data__.id, 1)
          // this_.nodes.splice(d3.select(this)._groups[0][0].__data__.id, 1)
        }
      });
      d3.selectAll(".linksText").each(function (e) {
        if (e.source === curr || e.target === curr) {
          d3.select(this).remove();
        }
      });
      this_.gs.style("opacity", 1);
      this_.links.style("opacity", 1).classed("link-active", false);
    },
    isLinkLine(node, link) {
      return link.source.id === node.id;
    },
    toggleLine(linkLine, currNode, isHover) {
      if (isHover) {
        // 加重连线样式
        this.links
          .style("opacity", 0.1)
          .filter(link => this.isLinkLine(currNode, link))
          .style("opacity", 1)
          .classed("link-active", true);
      } else {
        this.links.style("opacity", 1).classed("link-active", false);
      }
    },
    toggleLineText(currNode, isHover) {
      if (isHover) {
        this.linksText.style("fill-opacity", function (edge) {
          if (edge.source === currNode) {
            return 1;
          }
        });
      } else {
        this.linksText.style("fill-opacity", function (edge) {
          if (edge.source === currNode || edge.target === currNode) {
            return 0;
          }
        });
      }
    },
    // 生成关系连线路径
    genLinkPath(link) {
      const count = link.count;
      const index = link.index;
      let sx = link.source.x;
      let tx = link.target.x;
      let sy = link.source.y;
      let ty = link.target.y;
      return "M" + sx + "," + sy + " L" + tx + "," + ty;
    },
    ticked() {
      // 连线路径
      this.links.attr("d", link => this.genLinkPath(link));
      // 连线文字位置
      this.linksText
        .attr("x", function (d) {
          return (d.source.x + d.target.x) / 2;
        })
        .attr("y", function (d) {
          return (d.source.y + d.target.y) / 2;
        });
      // 节点位置
      this.gs.attr("transform", function (d) {
        return "translate(" + d.x + "," + d.y + ")";
      });
    },
    // 关联节点去重重组
    uniqObjInArray(objarray) {
      let len = objarray.length;
      let tempJson = {};
      let res = [];
      for (let i = 0; i < len; i++) {
        //取出每一个对象
        tempJson[JSON.stringify(objarray[i])] = true;
      }
      let keyItems = Object.keys(tempJson);
      for (let j = 0; j < keyItems.length; j++) {
        res.push(JSON.parse(keyItems[j]));
      }
      return res;
    },
    // //删除当前节点下一级没有其他关系的节点
    // deleteNextNodes(curr) {
    //   let this_ = this
    //   this_.is_node_focus = false // 删除节点隐藏右侧菜单
    //   // document.getElementById('remarks').innerText = '';
    //   // var removeIndex = nodesData.findIndex(node=>node.id == curr.id)
    //   // nodesData.splice(removeIndex,1)
    //   // nodes.splice(removeIndex,1)
    //   d3.select(this).remove();
    //   let relationNode = [],
    //     relationList = [],
    //     hasRelationList = []
    //   var clickNode = curr.id;//点击节点的名字
    //   d3.selectAll(".lines").each(function (e) {
    //     if (e.source.id == curr.id || e.target.id == curr.id) {
    //       hasRelationList.push(e)
    //     } else {
    //       relationList.push(e)//出去跟删除节点有关系的其他关系
    //     }
    //     //需要删除的节点相关的节点
    //     if (e.source.id == curr.id) {
    //       relationNode.push(e.target)
    //     }
    //     //需要删除的节点相关的节点
    //     if (e.target.id == curr.id) {
    //       relationNode.push(e.source)
    //     }
    //   })
    //   var tempNodeList = JSON.parse(JSON.stringify(relationNode))
    //   tempNodeList = this.uniqObjInArray(tempNodeList)
    //   //区分下级节点是否是孤节点
    //   tempNodeList.forEach(function (item, index) {
    //     var hasLine = relationList.findIndex(jtem => jtem.target.id == item.id || jtem.source.id == item.id)
    //     if (hasLine >= 0) {
    //       item.notSingle = true
    //     }
    //   })
    //   tempNodeList.forEach(function (item, index) {
    //     if (!item.notSingle) {
    //       d3.select('#singleNode' + item.id).remove()
    //     }
    //   })
    //   var otherTempNode = [];
    //   tempNodeList = tempNodeList.map(item => {
    //     if (!item.notSingle) {
    //       otherTempNode.push(item)
    //     }
    //   })
    //   hasRelationList.forEach(item => {
    //     otherTempNode.forEach(jtem => {
    //       if (jtem.id == item.source.id || jtem.id == item.target.id) {
    //         d3.select('#edgepath' + item.id).remove()
    //       }
    //     })
    //   })
    //   d3.selectAll(".singleNode").each(function (d, i) {
    //     var temp = d.id;
    //     //删除当前需要隐藏的节点
    //     if (temp == clickNode) {
    //       this_.removeSingle()
    //     }
    //   });
    //   d3.selectAll(".linksText").each(function (e) {
    //     if (e.source === curr || e.target === curr) {
    //       d3.select(this).remove();
    //     }
    //   })
    //   this.gs.style('opacity', 1);
    //   this_.links.style('opacity', 1)
    //     .classed('link-active', false);
    // },
    toggleNode(nodeCircle, currNode, isHover, linkMap) {
      if (isHover) {
        // 提升节点层级
        // nodeCircle.sort((a, b) => a.id === currNode.id ? 1 : -1);
        // this.parentNode.appendChild(this);
        nodeCircle
          .style("opacity", 0.1)
          .filter(node => this.isLinkNode(currNode, node, linkMap))
          .style("opacity", 1);
      } else {
        nodeCircle.style("opacity", 1);
      }
    },
    isLinkNode(currNode, node, linkMap) {
      if (currNode.id === node.id) {
        return true;
      }
      return linkMap[currNode.id + "-" + node.id] || linkMap[node.id + "-" + currNode.id];
    },
    genLinks(relations, nodesMap, linkMap) {
      const indexHash = {};
      return relations.map(function ({ id, source, target, relation, value }, i) {
        const linkKey = source + "-" + target;
        const count = linkMap[linkKey];
        if (indexHash[linkKey]) {
          indexHash[linkKey] -= 1;
        } else {
          indexHash[linkKey] = count - 1;
        }
        return {
          id,
          source: nodesMap[source],
          target: nodesMap[target],
          relation,
          value,
          relations: linkMap[linkKey + "-relation"],
          count: linkMap[linkKey],
          index: indexHash[linkKey],
        };
      });
    },
    genLinkMap(relations) {
      const hash = {};
      relations.map(function ({ source, target, relation }) {
        const key = source + "-" + target;
        if (hash[key]) {
          hash[key] += 1;
          hash[key + "-relation"] += "、" + relation;
        } else {
          hash[key] = 1;
          hash[key + "-relation"] = relation;
        }
      });
      return hash;
    },
    genNodesMap(nodes) {
      const hash = {};
      nodes.map(function ({ id, name, type, detail_url, desc }) {
        hash[id] = {
          id,
          name,
          type,
          detail_url,
          desc,
        };
      });
      return hash;
    },
    showMyList(cur_node_id, kg_extend_data) {
      // 节点查重，id重复节点不加入知识图谱
      for (let i = 0; i < kg_extend_data.nodes.length; i++) {
        let repeat_flag = false;
        for (let k = 0; k < this.nodes.length; k++) {
          if (kg_extend_data.nodes[i].id == this.nodes[k].id) {
            repeat_flag = true;
            break;
          }
        }
        if (!repeat_flag) this.nodes.push(kg_extend_data.nodes[i]);
      }
      // 关系查重，id重复关系不加入知识图谱
      for (let i = 0; i < kg_extend_data.relationships.length; i++) {
        let repeat_flag = false;
        for (let k = 0; k < this.tempEdges.length; k++) {
          if (kg_extend_data.relationships[i].id == this.tempEdges[k].id) {
            repeat_flag = true;
            break;
          }
        }
        if (!repeat_flag) this.tempEdges.push(kg_extend_data.relationships[i]);
      }
      // // alert(1111)
      // // 节点全部重复了，那不需要展开知识图谱
      // // console.log(this.nodes)
      // // console.log(kg_extend_data.nodes)
      // // console.log(this.tempEdges)
      // // console.log(kg_extend_data.relationships)
      // if(kg_extend_data.nodes.length==this.nodes.length && kg_extend_data.relationships.length==this.tempEdges.length)
      //   console.log('节点全部重复了，不需要展开知识图谱')
      //   return

      // 删除没有两端都连接到节点的边
      let node_id_list = [];
      let new_tempEdges = [];
      for (let i = 0; i < this.nodes.length; i++) node_id_list.push(this.nodes[i].id);
      for (let k = 0; k < this.tempEdges.length; k++) {
        if (node_id_list.indexOf(this.tempEdges[k].source) != -1 && node_id_list.indexOf(this.tempEdges[k].target) != -1) new_tempEdges.push(this.tempEdges[k]);
      }
      this.tempEdges = new_tempEdges;

      // var e = { id: 10, name: "河北", type: 1, desc: 'eqweweqeqweqeqweqw' };
      // var h = { id: 11, name: "河南", type: 2, desc: '31eeeee2313好耶好耶好耶好耶好耶好耶好耶好耶好耶' };
      // var f = { id: 13, source: 2, target: 10, relation: '222'};
      // this.nodes.push(e);
      // this.nodes.push(h);
      // this.tempEdges.push(f);
      let nodesMap = this.genNodesMap(this.nodes);
      this.nodesData = d3.values(nodesMap);
      let linkMap = this.genLinkMap(this.tempEdges);
      this.edges = this.genLinks(this.tempEdges, nodesMap, linkMap);
      // alert(this_.links)
      this.updateData(linkMap);
      let cur_node_elm_id = "#singleNode" + String(cur_node_id);
      // console.log(cur_node_id)
      // console.log(cur_node_elm_id)
      // console.log(document.getElementById(cur_node_elm_id))
      d3.select(cur_node_elm_id).dispatch("click");
      // document.getElementById(cur_node_elm_id).click()
      // console.log(document.getElementById(cur_node_elm_id))
    },
    removeSingle() {
      d3.select(".singleCircle").remove();
    },
    toggleCircle(current, d) {
      // console.log('32142141241341414    ', this.links.data(this.edges, function (d) {}).join("path"))
      let this_ = this;
      var currentD = d;
      if (d.clickFlag) {
        this.removeSingle();
        // document.getElementById('remarks').innerText = ''
        this_.is_node_focus = false; // 找不到节点隐藏右侧菜单
      }
      d.clickFlag = true;

      document.getElementById("remarks").innerText = d.name;
      if (d.detail_url) {
        document.getElementById("remarks").href = d.detail_url;
        // document.getElementById('remarks').pointerEvents = 'all'
        document.getElementById("remarks").onclick = function () {
          return window.open(d.detail_url, "_blank");
        }; // 没有详情链接，a标签设置不可点击
        document.getElementById("remarks").style.cursor = "pointer";
        document.getElementById("remarks").style.color = "#01899a";
        // document.getElementById('remarks').style.textDecoration = 'none'
      } else {
        document.getElementById("remarks").onclick = function () {
          return false;
        }; // 没有详情链接，a标签设置不可点击
        // document.getElementById('remarks').pointerEvents = 'none'
        // document.getElementById('remarks').href = 'javascript:void(0)'
        document.getElementById("remarks").style.cursor = "initial";
        document.getElementById("remarks").style.color = "#000";
        document.getElementById("remarks").style.textDecoration = "none";
      }
      if (d.desc) {
        document.getElementById("desc_lab").style.display = "block";
        document.getElementById("desc").innerText = d.desc;
      } else {
        document.getElementById("desc_lab").style.display = "none";
        document.getElementById("desc").innerText = "";
      }
      if (d.type == "__Document__") {
        document.getElementById("type").innerText = "文章";
        document.getElementById("type").style.backgroundColor = this_.node_color_choice[0];
      } else if (d.type == "__Entity__") {
        document.getElementById("type").innerText = "知识点";
        document.getElementById("type").style.backgroundColor = this_.node_color_choice[1];
      } else if (d.type == "__Community__") {
        document.getElementById("type").innerText = "社区";
        document.getElementById("type").style.backgroundColor = this_.node_color_choice[2];
      }

      var data = [
        // {
        //   population: 30,
        //   value: '刪 除',
        //   type: 'delete'
        // },
        {
          population: 30,
          value: "收 起",
          type: "showOn",
        },
        {
          population: 30,
          value: "展 开",
          type: "showOff",
        },
      ];
      var sum = d3.sum(
        data.map(function (d) {
          return d.population;
        })
      );
      for (let i in data) {
        data[i].Percentage = ((data[i].population / sum) * 100).toFixed(0) + "%";
      }
      var width = 300,
        height = 300,
        margin = { left: 30, top: 30, right: 30, bottom: 30 },
        svg_width = width + margin.left + margin.right,
        svg_height = height + margin.top + margin.bottom,
        font_size = 15;
      var g = current.append("g").attr("class", "singleCircle").attr("width", width).attr("height", height);
      var Pie = g.append("g");

      var arc_generator = d3
        .arc()
        .innerRadius(width / 8)
        .outerRadius(width / 4);
      var angle_data = d3.pie().value(function (d) {
        return d.population;
      });
      var pieData = angle_data(data);
      var pieAngle = pieData.map(function (p) {
        return ((p.startAngle + p.endAngle) / 2 / Math.PI) * 180;
      });

      // var color=d3.schemeCategory10;
      //生成内部圆环
      Pie.selectAll("path")
        .data(angle_data(data))
        .enter()
        .append("path")
        .attr("d", arc_generator)
        .style("fill", function (d, i) {
          return "#ddd";
        })
        // .style('stroke', 'black')
        .attr("class", "path")
        .attr("type", function (d) {
          return d.data.type;
        })
        .on("mouseover", function () {
          d3.select(this).style("fill", "#d3d7dc").transition().style("fill", "#aaaeb4");
        })
        .on("mouseout", function () {
          d3.select(this).style("fill", "#aaaeb4").transition().style("fill", "#d3d7dc");
        })
        .on("click", function (d) {
          if (d.data.type === "delete") {
            this_.deleteNode(currentD);
            // console.log(this_.nodes)
            // console.log(this_.tempEdges)
          } else if (d.data.type === "showOn") {
            this_.deleteNextNodes(currentD);
          } else if (d.data.type === "showOff") {
            this_.getKnowledgeDataAndExtendGraph(currentD);
            // this_.showMyList(currentD)
            //deleteNextNodes(currentD)
          } else {
            // showMyList()
          }
          d3.event.stopPropagation();
        });
      var arc_label = d3
        .arc()
        .innerRadius(width / 4)
        .outerRadius(width / 2);

      Pie.selectAll(".arc_label").data(angle_data(data)).enter().append("path").attr("d", arc_label).attr("class", "arc_label").style("fill", "none");
      const labelFontSize = 13;
      const labelValRadius = 170 * 0.35 - labelFontSize * 0.35; // 计算正确半径 文字位置
      const labelValRadius1 = 170 * 0.35 + labelFontSize * 0.35;

      const labelsVals = current.select(".singleCircle").append("g").classed("labelsvals", true);

      // 定义两条路径以使标签的方向正确
      labelsVals.append("def").append("path").attr("id", "label-path-1").attr("d", `m0 ${-labelValRadius} a${labelValRadius} ${labelValRadius} 0 1,1 -0.01 0`);
      labelsVals.append("def").append("path").attr("id", "label-path-2").attr("d", `m0 ${-labelValRadius1} a${labelValRadius1} ${labelValRadius1} 0 1,0 0.01 0`);

      labelsVals
        .selectAll("text")
        .data(data)
        .enter()
        .append("text")
        .style("font-size", labelFontSize)
        .style("fill", "#222")
        // .style('font-weight', "bold")
        .style("text-anchor", "middle")
        .append("textPath")
        .attr("href", function (d, i) {
          const p = pieData[i];
          const angle = pieAngle[i];
          if (angle > 90 && angle <= 270) {
            // 根据角度选择路径
            return "#label-path-2";
          } else {
            return "#label-path-1";
          }
        })
        .attr("startOffset", function (d, i) {
          const p = pieData[i];
          const angle = pieAngle[i];
          let percent = ((p.startAngle + p.endAngle) / 2 / 2 / Math.PI) * 100;
          if (angle > 90 && angle <= 270) {
            // 分别计算每条路径的正确百分比
            return 100 - percent + "%";
          }
          return percent + "%";
        })
        .text(function (d) {
          return d.value;
        })
        .on(
          "click",
          function (d) {
            if (d.type === "delete") {
              this_.deleteNode(currentD);
              // console.log(this_.nodes)
              // console.log(this_.tempEdges)
            } else if (d.type === "showOn") {
              this_.deleteNextNodes(currentD);
            } else if (d.type === "showOff") {
              this_.getKnowledgeDataAndExtendGraph(currentD);
              // this_.showMyList(currentD)
              //deleteNextNodes(currentD)
            } else {
              // showMyList()
            }
            d3.event.stopPropagation();
          },
          true
        );
      current.select(".singleCircle").style("transform", "rotate(-90deg)"); // 定义轮盘旋转角度
    },

    updateData(linkMap) {
      let this_ = this;
      // console.log('this3124141', this_.links
      //   .data(this_.edges, function (d) { }))
      // debugger;
      // console.log('this3124141')
      // console.log('this'+this)
      // console.log('this.links'+this.links)
      // alert(this.links
      //   .data(this.edges, function (d) {
      //   }))
      this_.links = this_.links
        .data(this_.edges, function (d) {})
        .join("path")
        .attr("id", (d, i) => {
          return "edgepath" + d.id;
        }) // 设置id，用于连线文字
        .style("stroke", this_.link_color_choice[0]) // 颜色
        .style("stroke-width", 2) // 粗细
        .attr("class", "lines")
        .attr("marker-end", "url(#resolved)") // 根据箭头标记的id号标记箭头
        .merge(this_.links);
      this_.linksText = this_.linksText
        .data(this_.edges)
        .join("text")
        .attr("class", "linksText")
        .text(function (d) {
          return d.relations;
        })
        .style("font-size", 14)
        .attr("fill-opacity", 0);
      this_.gs = this_.gs
        .data(this_.nodesData, function (d) {})
        .join("g")
        .attr("class", "singleNode")
        .attr("id", function (d) {
          return "singleNode" + d.id;
        })
        .style("cursor", "pointer")
        .merge(this_.gs)
        .call(d3.drag().on("start", this_.started).on("drag", this_.dragged).on("end", this_.ended));
      this_.gs
        .append("circle")
        .attr("fill", function (d) {
          if (d.type == "__Document__") {
            return this_.node_color_choice[0];
          } else if (d.type == "__Entity__") {
            return this_.node_color_choice[1];
          } else {
            return this_.node_color_choice[2];
          }
        })
        .attr("r", 35);
      // .attr('stroke', 'grey')
      // .attr('stroke-width', 3)
      this_.gs
        .on("mouseover", function (d, i) {
          // 显示连接线上的文字
          this_.toggleLineText(d, true);
          this_.toggleLine(this_.links, d, true);
          this_.toggleNode(this_.gs, d, true, linkMap);
        })
        .on("mouseout", function (d, i) {
          // 隐去连接线上的文字
          this_.toggleLineText(d, false);
          this_.toggleLine(this_.links, d, false);
          this_.toggleNode(this_.gs, d, false, linkMap);
        })
        .on(
          "click",
          function (d, i) {
            this_.linksText.style("fill-opacity", function (edge) {
              if (edge.source === d) {
                return 1;
              }
            });
            this_.toggleCircle(d3.select(this), d);
            this_.extendOtherMsg(d); // 获取对应节点扩展信息
            this_.is_node_focus = true; // 展示右侧菜单
          },
          true
        );
      this_.gs
        .append("text")
        .attr("y", -20)
        .attr("dy", 10)
        .attr("text-anchor", "middle")
        .style("font-size", 12)
        .attr("x", function ({ name }) {
          // return this_.textBreaking(d3.select(this), name)   // 超出换行
          return this_.textHiding(d3.select(this), name); // 超出隐藏
        });
      this_.gs.append("title").text(node => {
        return node.name;
      });
      this_.forceSimulation.nodes(this_.nodesData);
      // debugger;
      this_.forceSimulation.force("link").links(this_.edges);
      this_.forceSimulation.alpha(0.8).restart();
    },

    // // 获取页内屏幕宽高
    // get_inner_screen_size() {
    //   const width = window.innerWidth;
    //   const height = window.innerHeight - 20;
    //   return [width, height]
    // },
    drawChart() {
      let this_ = this;

      let marge = { top: 60, bottom: 60, left: 60, right: 60 };
      let svg = d3.select("#cxstar_knowledge_graph");
      let width = svg.attr("width");
      let height = svg.attr("height");
      svg
        .call(
          d3.zoom().on("zoom", function () {
            g.attr("transform", d3.event.transform);
          })
        )
        .on("dblclick.zoom", null);
      let g = svg
        .append("g")
        .attr("transform", "translate(" + marge.top + "," + marge.left + ")")
        .attr("class", "container");

      // 生成 nodes map
      let nodesMap = this.genNodesMap(this.nodes);
      // console.log('3333', nodesMap)
      this.nodesData = d3.values(nodesMap);
      let linkMap = this.genLinkMap(this.tempEdges);
      // 构建 links（source 属性必须从 0 开始）
      this.edges = this.genLinks(this.tempEdges, nodesMap, linkMap);
      // console.log('123123', this.edges, this.nodesData)
      // 设置一个颜色比例尺
      let colorScale = d3.scaleOrdinal().domain(d3.range(this.nodesData.length)).range(d3.schemeCategory10);

      // 新建一个力导向图
      this.forceSimulation = d3
        .forceSimulation()
        .force("link", d3.forceLink().distance(60).strength(0.5))
        .force("charge", d3.forceManyBody().strength(-50))
        .force("center", d3.forceCenter())
        .force("x", d3.forceX().strength(0.1))
        .force("y", d3.forceY().strength(0.1))
        .force("collide", d3.forceCollide().radius(70).strength(0.5)); // 碰撞力, radius(碰撞半径)

      // 生成节点数据
      this.forceSimulation.nodes(this.nodesData);
      // 生成边数据
      this.forceSimulation.force("link").links(this.edges);
      // .distance(function (d) { // 每一边的长度
      //   return d.value * 200
      // })
      // 设置图形中心位置
      this.forceSimulation
        .force("center")
        .x(width / 2)
        .y(height / 2);
      // 箭头
      var marker = g
        .append("g")
        .attr("class", "showLine")
        .append("marker")
        .attr("id", "resolved")
        // .attr("markerUnits","strokeWidth")// 设置为strokeWidth箭头会随着线的粗细发生变化
        .attr("markerUnits", "userSpaceOnUse")
        .attr("viewBox", "0 -5 10 10") // 坐标系的区域
        .attr("refX", 44) // 箭头坐标
        .attr("refY", 0)
        .attr("markerWidth", 10) // 标识的大小
        .attr("markerHeight", 10)
        .attr("orient", "auto") // 绘制方向，可设定为：auto（自动确认方向）和 角度值
        .attr("stroke-width", 2) // 箭头宽度
        .append("path")
        .attr("d", "M0,-5L10,0L0,5") // 箭头的路径
        .attr("fill", "#bbb"); // 箭头颜色
      // 绘制边
      this.links = g
        .append("g")
        .selectAll("path")
        .data(this.edges)
        .enter()
        .append("path")
        .attr("d", link => this.genLinkPath(link)) // 遍历所有数据。d表示当前遍历到的数据，返回绘制的贝塞尔曲线
        .attr("id", (d, i) => {
          return "edgepath" + d.id;
        }) // 设置id，用于连线文字
        .style("stroke", "#bbb") // 颜色
        .style("stroke-width", 2) // 粗细
        .attr("class", "lines")
        .attr("marker-end", "url(#resolved)"); // 根据箭头标记的id号标记箭头

      // 边上的文字
      this.linksText = g
        .append("g")
        .selectAll("text")
        .data(this.edges)
        .enter()
        .append("text")
        .attr("class", "linksText")
        .text(function (d) {
          return d.relations;
        })
        .style("font-size", 14)
        .attr("fill-opacity", 0);
      // 创建分组
      this.gs = g
        .append("g")
        .selectAll(".circleText")
        .data(this.nodesData)
        .enter()
        .append("g")
        .attr("class", "singleNode")
        .attr("id", function (d) {
          return "singleNode" + d.id;
        })
        .style("cursor", "pointer")
        .attr("transform", function (d) {
          let cirX = d.x;
          let cirY = d.y;
          return "translate(" + cirX + "," + cirY + ")";
        });
      // 鼠标交互
      this.gs
        .on("mouseover", function (d, i) {
          // 显示连接线上的文字
          this_.toggleLineText(d, true);
          this_.toggleLine(this_.links, d, true);
          this_.toggleNode(this_.gs, d, true, linkMap);
        })
        .on("mouseout", function (d, i) {
          // 隐去连接线上的文字
          this_.toggleLineText(d, false);
          this_.toggleLine(this_.links, d, false);
          this_.toggleNode(this_.gs, d, false, linkMap);
        })
        .on(
          "click",
          function (d, i) {
            this_.linksText.style("fill-opacity", function (edge) {
              if (edge.source === d) {
                return 1;
              }
            });
            this_.toggleCircle(d3.select(this), d);
            this_.extendOtherMsg(d); // 获取对应节点扩展信息
            this_.is_node_focus = true; // 展示右侧菜单
          },
          true
        )
        .call(d3.drag().on("start", this_.started).on("drag", this_.dragged).on("end", this_.ended));
      svg.on(
        "click",
        function () {
          this_.nodes.forEach(d => (d.clickFlag = false));
          var event = d3.event;
          var target = event.srcElement, //  获取事件发生源
            data = d3.select(target).datum(); //  获取事件发生源的数据
          // console.log(data)
          this_.removeSingle();
          if (!data) {
            // document.getElementById('remarks').innerText = ''
            this_.is_node_focus = false; // 点击的不是节点的话，隐藏右侧菜单
          }
        },
        true
      );
      this.forceSimulation.on("tick", this.ticked);
      function getLineTextAngle(d, bbox) {
        if (d.target.x < d.source.x) {
          const { x, y, width, height } = bbox;
          const rx = x + width / 2;
          const ry = y + height / 2;
          return "rotate(180 " + rx + " " + ry + ")";
        } else {
          return "rotate(0)";
        }
      }
      function largerNode(nodes, currNode, isHover) {
        if (isHover) {
          this.gs
            .style("stroke-width", 1)
            .filter(node => isNode(currNode, node))
            .style("stroke-width", 10);
        } else {
          this.gs.style("stroke-width", 1);
        }
      }
      function isNode(node, cNode) {
        return true;
      }
      // 绘制节点
      this.gs
        .append("circle")
        .attr("r", function (d, i) {
          if (d.type == "__Document__") {
            return 35;
          } else {
            return 33;
          }
        })
        .attr("id", function (d) {
          return "circle" + d.id;
        })
        .attr("fill", function (d, i) {
          if (d.type == "__Document__") {
            return this_.node_color_choice[0];
          } else if (d.type == "__Entity__") {
            return this_.node_color_choice[1];
          } else {
            return this_.node_color_choice[2];
          }
        });
      // .attr('stroke', 'grey')
      // .attr('stroke-width', 3)
      // 文字
      var nodeText = this.gs
        .append("text")
        // .attr('x', -10)
        .attr("y", -20)
        .attr("dy", 10)
        .attr("text-anchor", "middle")
        .style("font-size", 12)
        .attr("x", function ({ name }) {
          // return this_.textBreaking(d3.select(this), name)      // 文本换行
          return this_.textHiding(d3.select(this), name); // 超出隐藏
        });
      this.gs.append("title").text(node => {
        return node.name;
      });
    },
  },
};
</script>

<style>
/* svg {
  background-color: #d1e9ff;
} */
/* a {
  color: #01899a;
  text-decoration: none;
}
a:hover {
  color: #2d8cf0;
  text-decoration: none;
} */
.ellipsis {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

#legend {
  display: flex;
  justify-content: left;
  padding: 20px 30px;
}
.legend-item {
  display: flex;
  align-items: center;
  margin-right: 10px;
  border-radius: 5px;
  font-size: 12px;
  padding: 6px 12px;
  cursor: pointer;
}
.no-pointer-events {
  pointer-events: none;
}
</style>
